// TODO: Do we actually need all those for landing? Cleanup to avoid unnecessary loads
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import "@fontsource/caveat/700.css";

import ReactDOM from "react-dom/client";

import { initializeAttributionTracking } from "./src/utils/trackingUtils";

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const wrapPageElement = ({ element }) => element;

/** Initialize attribution tracking when the client-side application starts */
export const onClientEntry = () => {
  initializeAttributionTracking();
};
